const PersonageMain = () => import('@/views/personage/main')
const PersonageDetail = () => import('@/views/personage/detail')
const PersonageResource = () => import('@/views/personage/resource')
const PersonageResourceBook = () => import('@/views/personage/resource/book')

export default [
    {
        path: '/personage/main',
        name: 'PersonageMain',
        component: PersonageMain,
        meta: {
            title: '历史名人'
        }
    },
    {
        path: '/personage/detail/:id',
        name: 'PersonageDetail',
        component: PersonageDetail,
        props: true,
        meta: {
            title: '个人专题数据库'
        }
    },
    // 历史名人相关资源
    {
        path: '/personage/resource/:id/:resType',
        name: 'PersonageResource',
        component: PersonageResource,
        props: true,
        meta: {
            title: '相关资源'
        }
    },
    // 历史名人图书详情
    {
        path: '/personage/r/book/:id',
        name: 'PersonageResourceBook',
        props: true,
        component: PersonageResourceBook,
        meta: {
            title: '书籍资源'
        }
    },
]
